var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49986 0C7.20994 0 7.78557 0.575634 7.78557 1.28571V10.1817L9.87644 8.09086C10.3785 7.58876 11.1926 7.58876 11.6947 8.09086C12.1968 8.59297 12.1968 9.40703 11.6947 9.90914L7.409 14.1949C7.16788 14.436 6.84085 14.5714 6.49986 14.5714C6.15887 14.5714 5.83184 14.436 5.59072 14.1949L1.30501 9.90914C0.802906 9.40703 0.802906 8.59297 1.30501 8.09086C1.80711 7.58876 2.62118 7.58876 3.12328 8.09086L5.21415 10.1817V1.28571C5.21415 0.575634 5.78978 0 6.49986 0ZM0.0712891 16.7143C0.0712891 16.0042 0.646923 15.4286 1.357 15.4286H11.6427C12.3528 15.4286 12.9284 16.0042 12.9284 16.7143C12.9284 17.4244 12.3528 18 11.6427 18H1.357C0.646923 18 0.0712891 17.4244 0.0712891 16.7143Z",
    fill: "rgb(79, 70, 229)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadActive);
export default __webpack_public_path__ + "static/media/download_active.d42de77fcb5870d8aeddb0c1e0d27227.svg";
export { ForwardRef as ReactComponent };